import script from "./InstallDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstallDialog.vue?vue&type=script&setup=true&lang=ts"

import "./InstallDialog.vue?vue&type=style&index=0&id=595c46c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595c46c2"]])

export default __exports__